import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUserPushNotificationsV1Response } from './get-user-push-notifications-v1-response';
import { getUserPushNotificationsV1ResponseSchema } from './get-user-push-notifications-v1-response';

export async function getUserPushNotificationsV1Api(
  userId: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetUserPushNotificationsV1Response>> {
  return getRequest<IGetUserPushNotificationsV1Response>({
    path: `/sys/users/v1/${userId}/push`,
    schema: getUserPushNotificationsV1ResponseSchema,
    options,
  });
}
